@if (model && model.organizationId) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <control-linkable
            #linkable
            displayValueProp="name"
            [(linked)]="linked"
            [unlinked]="unlinked"
            [hideActions]="true"
            [orderByValueProperty]="true"
            [allowAddNew]="permissions.canAddControls"
            [disabled]="!permissions.canLinkControls"
            [parentModuleType]="moduleType.ORM"
            [parentId]="model.id"
            [parentOrganizationId]="model.organizationId"
            [parentBusinessDimensions]="model.businessDimensionIds"
            [parentFrameworkDimensions]="model.frameworkDimensionIds"
            (linkedChange)="linkedChanged($event)"
            (onReloadClicked)="reloadClicked()"
        >
        </control-linkable>
    }
} @else {
    <div>{{ 'selectOrgFirst' | t }}</div>
}
